import clsx from 'clsx'
import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import SideMenu from '../sections/aside/SideMenu'
import Footer from '../sections/Footer'
import HeaderWrapper from '../sections/header/HeaderWrapper'
import { PageDataProvider, useLayout } from './core'
import LoadingSpinner from '../components/LoadingSpinner'

const MasterLayout: React.FC = () => {
  const { classes } = useLayout()

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <SideMenu />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />
          <div id='kt_content' className='d-flex flex-column flex-column-fluid mt-n12'>
            {/* <Toolbar /> */}
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <div id='kt_content_container' className={clsx(classes.contentContainer.join(' '))}>
                <Suspense fallback={<LoadingSpinner />}>
                  <Outlet />
                </Suspense>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* begin:: Drawers */}

      {/* end:: Drawers */}

      {/* begin:: Modals */}

      {/* end:: Modals */}
    </PageDataProvider>
  )
}

export { MasterLayout }
